import React from "react";
import {useTranslation} from "react-i18next";
import {useTheme} from "connectui/theme/ThemeProvider";
import {buildStyles} from "connectui/component/buildStyles";
import BottomSheetModal from "connectui/component/modal/BottomSheetModal";
import FlexContainer from "connectui/component/layout/FlexContainer";
import ListComponent from "connectui/component/layout/list/ListComponent";
import ICONS from "connectui/icons/iconMap";
import Text from "connectui/component/display/Text";
import SvgIcon from "connectui/component/display/SvgIcon";
import ButtonText from "connectui/component/input/button/ButtonText";

const useStyles = (theme) =>
  buildStyles({
    channelIcon: {
      width: "20px",
      height: "20px",
      padding: "1px",
      justifyContent: "center",
    },
    checkIcon: {
      width: "20px",
      height: "20px",
      color: theme.colors.primary,
      justifyContent: "flex-end !important",
    },
  });

export default function ChannelSelectorModal({
  isOpen,
  onClose,
  availableChannels,
  selectedChannel,
  setSelectedChannel,
  handleChannelClick,
}) {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const {t} = useTranslation();

  return (
    <BottomSheetModal
      isOpen={isOpen}
      title={t("mobile.inbox.channel-selector.header")}
      onClose={onClose}
      sx={{
        content: {
          padding: theme.spacing(3, 0, 0),
        },
      }}
    >
      <FlexContainer flexDirection="column" sx={{overflow: "hidden"}}>
        <ListComponent gap={"0px"} sx={{width: "100%"}}>
          {availableChannels.map(
            (channel) =>
              channel.show && (
                <FlexContainer
                  alignItems="center"
                  key={channel.id}
                  gap={theme.spacing(3)}
                  sx={{
                    padding: theme.spacing(2.5, 4),
                    backgroundColor:
                      selectedChannel === channel.id
                        ? theme.colors.gray50
                        : "transparent",
                  }}
                  onClick={() => setSelectedChannel(channel.id)}
                >
                  <SvgIcon
                    component={ICONS[channel.icon]}
                    className={classes.channelIcon}
                    sx={{
                      color: channel.color,
                    }}
                  />
                  <Text
                    variant="textSM"
                    weight="medium"
                    color="gray700"
                    sx={{flex: 1}}
                  >
                    {channel.label}
                  </Text>
                  {selectedChannel === channel.id && (
                    <SvgIcon
                      component={ICONS.check}
                      className={classes.checkIcon}
                    />
                  )}
                </FlexContainer>
              ),
          )}
        </ListComponent>
        <ButtonText
          weight="semibold"
          color="white"
          sx={{
            width: `calc(100% - ${theme.spacing(8)})`,
            padding: theme.spacing(2.5, 4.5),
            margin: theme.spacing(5, 4),
          }}
          label={t("mobile.inbox.channel-selector.apply-button")}
          onClick={() => {
            handleChannelClick(selectedChannel);
            onClose();
          }}
        />
      </FlexContainer>
    </BottomSheetModal>
  );
}
